export default "__VITE_ASSET__GYevzP4Z__"